<template>
  <div class="followup-plan">
    <a-form layout="inline" class="search">
      <a-form-item>
        <a-select
          :allowClear="true"
          class="select"
          v-model:value="followupStatus"
          placeholder="全部随访状态"
        >
          <a-select-option value="0">未开始</a-select-option>
          <a-select-option value="1">进行中</a-select-option>
          <a-select-option value="2">已完成</a-select-option>
          <a-select-option value="3">已终止</a-select-option>
          <a-select-option value="4">已超时</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-button @click="reset">重置</a-button>
        <a-button @click="onChangePage()" style="margin-left: 10px" type="primary">搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table
      class="table"
      :rowKey="(_, index) => index"
      :columns="ColFollowup"
      :data-source="list"
      @change="onChangePage"
      :scroll="{ x: '100%', y: 330 }"
      :transformCellText="({ text }) => text ?? '--'"
      :sortDirections="['descend', 'ascend']"
    >
      <!-- 查看详情 -->
      <template #operation="{ record }">
        <a-button
          v-for="item in btns"
          :key="item.key"
          class="button-link"
          type="link"
          @click="toFollowUp(record, item.type, item.title)"
        >
          {{ item.title }}
        </a-button>
      </template>
    </a-table>
    <FollowupIframe
      ref="FollowupIframeRef"
      :followupInfo="followupInfo"
      :title="followupTitle"
      :followUpType="followUpType"
    />
  </div>
</template>

<script setup>
import { getFollowPlanForPatientArchives } from '@/api/patientFile'
import { ColFollowup } from '@/components/PatientFile/config'
import { computed, ref, watch } from 'vue'
import FollowupIframe from './components/FollowupIframe/index.vue'
import { useStore } from 'vuex'
// import { message } from 'ant-design-vue'
const store = useStore()
const doctorInfo = computed(() => store.state.patientFile.bindUser.doctorInfo)
const info = computed(() => store.state.patientFile.info)
const list = ref([])
const followUpType = ref('')
const followupInfo = ref({})
const followupTitle = ref('')
const FollowupIframeRef = ref(null)
const pagination = ref({
  current: 1,
  pageSize: 10,
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
  showTotal: () => {}
})
const btns = [
  {
    key: 1,
    type: 'path',
    title: '随访路径'
  },
  {
    key: 2,
    type: 'detail',
    title: '随访详情'
  }
]
const followupStatus = ref(null)
const onChangePage = page => {
  pagination.value.current = page?.current || 1
  pagination.value.pageSize = page?.pageSize || 10
  getData()
}
function getData() {
  list.value = []
  const { ucPatientId } = info.value
  const { ucDoctorId } = doctorInfo.value
  const hasId = !!(ucDoctorId && ucPatientId)
  if (!hasId) {
    // message.warning('缺少医生患者信息，无法获取随访计划')
    return
  }
  const params = {
    ucPatientId: ucPatientId,
    ucDoctorId: ucDoctorId,
    followupStatus: followupStatus.value,
    curPage: 1,
    pageSize: 10
  }
  getFollowPlanForPatientArchives(params).then(result => {
    list.value = result.dataList
    pagination.value.total = result.total
    pagination.value.showTotal = () => `共${result.total}条`
  })
}
function reset() {
  followupStatus.value = null
  onChangePage()
}

// 随访路径/随访详情
const toFollowUp = (record, type, title) => {
  followUpType.value = type
  followupInfo.value = record
  followupTitle.value = title
  FollowupIframeRef.value.visible = true
}

watch(
  () => [info.value.ucPatientId, doctorInfo.value.ucDoctorId],
  () => {
    onChangePage()
  },
  { immediate: true }
)
</script>

<style lang="scss" scoped>
.followup-plan {
  .search {
    margin-bottom: 20px;
    .select {
      width: 200px;
    }
  }
}
.followUp-iframe {
  height: 100%;
  display: flex;
  overflow: hidden !important;
  .iframe {
    height: 100%;
    flex: 1;
    position: relative;
    .fullscreen {
      position: absolute;
      right: 50px;
      bottom: 150px;
      z-index: 999;
      cursor: pointer;
      width: 40px;
      height: 40px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .info-box {
    width: 400px;
    height: 100%;
    overflow: auto;
    background-color: #fff;
  }
}
</style>
